module.exports = __webpack_public_path__ + "static/media/51.724c9073.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/51.jpg
// module id = 419
// module chunks = 0